import { STORE_LOGO_UPLOAD } from '../../constants/storeCheckout.constants';
import type { IPublicPreSignedUrlRequest, S3SignedUrlResponse } from '@/api/S3Query';

type GetPublicPreSignedUrl = (payload: IPublicPreSignedUrlRequest) => Promise<S3SignedUrlResponse>;

export const buildStoreLogoUploadFileName = (file: File): string => {
  const extension = file.name.split('.').pop()?.toLowerCase() ?? 'png';
  const baseName = file.name
    .replace(/\.[^.]+$/, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
  const timestamp = Date.now();
  const randomSuffix = Math.random().toString(36).slice(2, 8);

  return `${baseName}-${timestamp}-${randomSuffix}.${extension}`;
};

export const buildStoreLogoPreSignedUrlPayload = (file: File): IPublicPreSignedUrlRequest => ({
  fileName: buildStoreLogoUploadFileName(file),
  fileSize: file.size,
  fileType: file.type,
  folder: STORE_LOGO_UPLOAD.S3_FOLDER,
  public: false,
});

export const uploadStoreLogoFileToS3 = async (
  file: File,
  getPublicPreSignedUrl: GetPublicPreSignedUrl
): Promise<string | null> => {
  const signed = await getPublicPreSignedUrl(buildStoreLogoPreSignedUrlPayload(file));

  if (!signed.signedRequest || !signed.fileName) {
    return null;
  }

  const uploadResponse = await fetch(signed.signedRequest, {
    method: 'PUT',
    body: file,
    headers: {
      'Content-Type': file.type,
      'x-amz-acl': 'private',
    },
  });

  if (!uploadResponse.ok) {
    return null;
  }

  return signed.fileName;
};
